import React, {Component} from "react";
import {withTranslate} from "react-redux-multilingual";
import Head from "../../components/Head";
import HistoryCard from "../../components/appointments/HistoryCard";
import {
    clearPastReservations,
    clearUpcomingReservations,
    getPastReservations,
    getUpcomingReservations,
    removeReservationFromList
} from "../../store/actions/reservationActions";
import {connect} from "react-redux";
import {setUpcomingReservationSkeleton, setUserHistorySkeleton} from "../../skeleton";
import Rating from "react-rating";
import axios from "axios";
import {addReportUrl, addReview, cancelReservationLink, getHeader, requestRefundURL} from "../../config";
import SweetAlert from 'react-bootstrap-sweetalert';
import AppointmentCard from "../../components/appointments/AppointmentCard";
import NoData from "../../components/NoData";
import {clearError500, setCurrentRoute} from "../../store/actions/globalActions";
import Maintenance from "../Home";
import NoMatch from "../doctors/DoctorAndHospitalProfile";


class UserHistory extends Component {
    state = {
        historyTab: "upcoming",

        reviewPopUp: false,
        content: "",
        rate: null,

        addReportPopUp: false,
        reportDesc: null,

        refundPopUp: false,
        showRequestRefund: false,
        requestRefundTitle: null,
        requestRefundText: null,
        requestRefundLoading: false,
        requestRefundSuccess: false,

        currentPastReservation: null,
        reservation_id: null,
        showSweetAlert: false,
        sweetAlertTitle: "",
        confirmSweetAlertBtnText: "",
        requestSweetAlertText: "",
        sweetAlertType: null,
        loading: false,
        reportLoading: false,
        showRequestSweetAlert: false,
        reservation: null,


        //activeTab: false,

        isRemovingReservationFromList: false,
        currentReservationInPage: null,

        pastReservationLimit: 6,
        pastReservationOffset: 0,
        reportIssues: [
            {
                id: 1,
                en_name: 'unable to book',
                ar_name: 'غير قادر على الحجز',
            },
            {
                id: 2,
                en_name: 'refund',
                ar_name: 'اعاده مال',
            },
            {
                id: 3,
                en_name: 'others',
                ar_name: 'اخرى',
            },
        ],
        addReportData: {
            body: null,
            type: null,
            reservation_id: null,
        },

    };

    constructor(props) {
        super(props);
        this.past_tab = React.createRef();
        this.upcoming_tab = React.createRef()
    }

    componentDidMount() {
        window.scrollTo(0, 0);
        this.props.setCurrentRoute(window.location.href);
        this.initPage();
    }


    initPage = () => {
        this.props.clearError500();
        this.props.clearUpcomingReservations();
        this.props.getUpcomingReservations();
        this.handleHistoryReservation(null, this.props.match.params.status ? this.props.match.params.status : "upcoming");

        if (this.props && this.props.location && this.props.location.state) {
            if (this.props.location.pastReservationRefund || this.props.location.state.pastReservationRefund) {
                this.handleHistoryReservation(null, "past");
            }
        }
    };


    changePopUpStatus = (e, status, element_id, reservation = null) => {
        if (status === "open") {
            if (element_id.includes("report")) {
                this.setState({
                    addReportPopUp: true,
                });
            } else if (element_id.includes("refund")) {
                this.setState({
                    refundPopUp: true,
                });
            } else if (element_id.includes("review")) {
                this.setState({
                    reviewPopUp: true,
                });
            }
            this.setState({
                currentPastReservation: reservation
            });
            document.getElementById(element_id).style.width = window.innerWidth + "px";
            document.getElementById(element_id).style.height = window.innerHeight + "px";
        } else {
            if (element_id.includes("report")) {
                this.setState({
                    addReportPopUp: false,
                });
            } else if (element_id.includes("refund")) {
                this.setState({
                    refundPopUp: false,
                });
            } else if (element_id.includes("review")) {
                this.setState({
                    reviewPopUp: false,
                });
            }
            document.getElementById(element_id).style.width = "0";
        }
    };

    changeAddReportPopUp = (e, status, reservation = null) => {
        e.preventDefault();
        if (status === "open") {
            this.setState({
                addReportPopUp: true,
                currentPastReservation: reservation
            });
            document.getElementById("add-report-overlay").style.width = window.innerWidth + "px";
            document.getElementById("add-report-overlay").style.height = window.innerHeight + "px";
        } else {
            this.setState({
                addReportPopUp: false,
            });
            document.getElementById("add-report-overlay").style.width = "0";
        }
    }
    changeReviewPopUp = (e, status, reservation = null) => {
        e.preventDefault();
        if (status === "open") {
            this.setState({
                reviewPopUp: true,
                currentPastReservation: reservation
            });
            document.getElementById("review-overlay").style.width = window.innerWidth + "px";
            document.getElementById("review-overlay").style.height = window.innerHeight + "px";
        } else {
            this.setState({
                reviewPopUp: false,
            });
            document.getElementById("review-overlay").style.width = "0";
        }
    };

    setReviewRate = (rate) => {
        this.setState({
            rate
        })
    };
    onConfirmSweetAlert = () => {
        if (this.state.sweetAlertType === "success") {
            this.setState({
                reviewPopUp: false,
                addReportPopUp: false,
                showSweetAlert: false,
            })
        } else {
            this.setState({
                showSweetAlert: false,
            })
        }
    };
    requestRefund = () => {
        this.setState({
            requestRefundLoading: true,
        });
        axios.post(requestRefundURL, {"reservation_id": this.state.currentPastReservation ? this.state.currentPastReservation.id : null},
            {headers: getHeader()}).then(response => {
            if (response.data.Error.code === 20) {
                this.setState({
                    showRequestRefund: true,
                    requestRefundTitle: this.props.translate('success'),
                    requestRefundText: this.props.translate('request_refund_success'),
                    requestRefundSuccess: true,
                    requestRefundLoading: false,
                });
            } else {
                this.setState({
                    showRequestRefund: true,
                    requestRefundTitle: this.props.translate('sorry'),
                    requestRefundText: response.data.Error.desc,
                    requestRefundLoading: false,
                })
            }
        }).catch(err => {
            this.setState({
                showRequestRefund: true,
                requestRefundTitle: this.props.translate('sorry'),
                requestRefundText: this.props.translate('something_wrong'),
                requestRefundLoading: true,
            });
        })
    };
    // agree Request Refund
    handleConfirmSweetAlert = () => {
        this.setState({
            showRequestRefund: false,
            refundPopUp: false
        }, () => {
            window.scrollTo(0, 0);
            this.props.clearPastReservations();
            this.props.getPastReservations(6, 0);
        });
    };

    setReservationReview = (e, currentReservation) => {
        e.preventDefault();
        this.setState({
            loading: true,
        });
        this.setState({
            reservation_id: currentReservation.id
        }, () => {
            axios.post(addReview, this.state, {headers: getHeader()}).then(res => {
                this.setState({
                    loading: false,
                });
                if (res.data.Error.status === true) {
                    this.setState({
                        sweetAlertType: "success",
                        showSweetAlert: true,
                        sweetAlertTitle: this.props.translate("thank_you"),
                        confirmSweetAlertBtnText: this.props.translate("ok"),
                        requestSweetAlertText: this.props.translate("review_added_successfully"),
                    });
                    window.scrollTo(0, 0);
                    this.props.clearPastReservations();
                    this.props.getPastReservations(6, 0);
                    this.setState({
                        pastReservationLimit: 6,
                        pastReservationOffset: 0,
                    })
                } else {
                    this.setState({
                        sweetAlertType: "failed",
                        showSweetAlert: true,
                        sweetAlertTitle: this.props.translate("sorry"),
                        confirmSweetAlertBtnText: this.props.translate("ok"),
                        requestSweetAlertText: res.data.Error.desc
                    })
                }
            }).catch(err => {
                this.setState({
                    loading: true,
                });
                console.log(err);
            })
        });
    };

    setPastReservationReport = (e, currentReservation) => {
        e.preventDefault();
        this.setState({
            reportLoading: true,
        });
        this.setState({
            addReportData: {
                ...this.state.addReportData,
                reservation_id: currentReservation.id
            }
        }, () => {
            axios.post(addReportUrl, this.state.addReportData, {headers: getHeader()}).then(res => {
                this.setState({
                    reportLoading: false,
                });
                if (res.data.Error.status === true) {
                    this.setState({
                        sweetAlertType: "success",
                        showSweetAlert: true,
                        sweetAlertTitle: this.props.translate("thank_you"),
                        confirmSweetAlertBtnText: this.props.translate("ok"),
                        requestSweetAlertText: this.props.translate("report_added_successfully"),
                    });
                    window.scrollTo(0, 0);
                    this.props.clearPastReservations();
                    this.props.getPastReservations(6, 0);
                    this.setState({
                        pastReservationLimit: 6,
                        pastReservationOffset: 0,
                    })
                } else {
                    this.setState({
                        sweetAlertType: "failed",
                        showSweetAlert: true,
                        sweetAlertTitle: this.props.translate("sorry"),
                        confirmSweetAlertBtnText: this.props.translate("ok"),
                        requestSweetAlertText: res.data.Error.desc
                    })
                }
            }).catch(err => {
                this.setState({
                    reportLoading: true,
                });
                console.log(err);
            })
        });
    };

    handleHistoryReservation = (e, status) => {
        if (e) {
            e.preventDefault();
            let siblings = document.querySelectorAll('.tab.active');
            e.currentTarget.classList.add("active");
            for (let i = 0; i < siblings.length; i++) {
                siblings[i].classList.remove('active');
            }
        }
        if (status === "upcoming") {
            window.history.pushState(null, null, "/my-appointments/upcoming");
            this.setState({
                historyTab: "upcoming"
            });
            this.props.clearUpcomingReservations();
            this.props.getUpcomingReservations();
        } else {
            window.history.pushState(null, null, "/my-appointments/past");
            this.setState({
                historyTab: "past"
            });
            this.props.clearPastReservations();
            this.props.getPastReservations(6, 0);
        }
    };


    cancelReservationSweetAlert = (reservation) => {
        this.setState({
            showRequestSweetAlert: true,
            reservation
        });
    };


    loadMorePastReservations = (e) => {
        e.preventDefault();
        this.setState({
                pastReservationOffset: this.state.pastReservationOffset + 6
            },
            () => {
                this.props.getPastReservations(this.state.pastReservationLimit, this.state.pastReservationOffset);
            }
        )
    };

    rescheduleReservation = (reservation) => {
        window.localStorage.setItem("rescheduleReservation", JSON.stringify(reservation));
        window.location.href = "/doctor/" + reservation.doctor.unique_id;
    };
    handleCancelReservation = (reservation) => {
        this.setState({
            isRemovingReservationFromList: true,
        });
        axios.post(cancelReservationLink, {
            reservation_id: reservation.id,
            status: 2
        }, {headers: getHeader()}).then(res => {
            this.setState({
                showRequestSweetAlert: false,
                isRemovingReservationFromList: false,
            }, () => {
                this.props.clearUpcomingReservations();
                this.props.getUpcomingReservations();
            });
            if (res.data.Error.code === 20) {
                this.props.removeReservationFromList(reservation);
                this.setState({
                    currentReservationInPage: this.props.upcomingReservations && this.props.upcomingReservations.length ? this.props.upcomingReservations[0] : null,
                });
            } else {
                this.setState({
                    showErrorSweetAlert: true
                })
            }
        }).catch(err => {
            this.setState({
                showErrorSweetAlert: true
            });
        });

    };
    handleInputChange = (e) => {
        this.setState({
            [e.target.id]: e.target.value
        });
    };
    handleAddReportChange = (e) => {
        this.setState({
            addReportData: {
                ...this.state.addReportData,
                [e.target.id]: e.target.value
            }
        });
    };

    render() {
        if (this.props.error500) {
            return (
                <Maintenance/>
            )
        }
        if (this.props.match.params.status) {
            if (this.props.match.params.status !== "past" && this.props.match.params.status !== "upcoming") {
                //console.log("no match", this.props.match.params.status);
                return (<NoMatch/>)
            }
        }
        const reportIssuesList = this.state.reportIssues ? this.state.reportIssues.map((issue, index) => {
            return (
                <option
                    value={issue.id}>{this.props.language === 'ar' ? issue.ar_name : issue.en_name}</option>
            )
        }) : null;
        const past_reservations = this.props.pastReservations && this.props.pastReservations.length ? this.props.pastReservations.map((reservation, index) => {
            return (
                <div className="col-md-6 col-xs-12 mb-30" key={index}>
                    <HistoryCard pastReservation={reservation}
                                 rescheduleReservation={() => this.rescheduleReservation(reservation)}
                                 changePopUpStatus={(e, status, element_id, reservation) => this.changePopUpStatus(e, status, element_id, reservation)}
                                 changeReviewPopUp={(e, status, reservation) => this.changeReviewPopUp(e, status, reservation)}
                                 changeAddReportPopUp={(e, status, reservation) => this.changeAddReportPopUp(e, status, reservation)}/>

                </div>
            )
        }) : <div className="no-reservations">
            <NoData image="no-reservations"/>
        </div>;
        const upcoming_reservations = this.props.upcomingReservations && this.props.upcomingReservations.length ? this.props.upcomingReservations.map((reservation, index) => {
            return (
                <div className="upcoming-res-card" key={index}>
                    <AppointmentCard language={this.props.language}
                                     cancelReservationSweetAlert={() => this.cancelReservationSweetAlert(reservation)}
                                     rescheduleReservation={() => this.rescheduleReservation(reservation)}
                                     currentReservation={reservation}/>
                </div>
            )
        }) : <div className="no-reservations">
            <NoData image="no-reservations"/>
        </div>;


        return (

            <div id="history">
                <Head title={this.props.translate("history")}/>
                <div className="container">
                    <div className="row">
                        <div className="text-center flex capitalized appointment-tabs cursor-pointer">
                            <div onClick={(e) => this.handleHistoryReservation(e, "upcoming")}
                                 className={this.props.match.params.status === "upcoming" || this.state.historyTab === "upcoming" ? 'tab-left tab active' : 'tab-left tab'}
                                 ref={this.upcoming_tab}>{this.props.translate("upcoming")}</div>
                            <div onClick={(e) => this.handleHistoryReservation(e, "past")}
                                 className={this.props.match.params.status === "past" || this.state.historyTab === "past" ? 'tab-right tab active' : 'tab-right tab'}
                                 id="past-tab" ref={this.past_tab}>{this.props.translate("past")}</div>
                        </div>
                    </div>
                    <div hidden={this.state.historyTab === "upcoming"}>
                        {!this.props.pastReservationsIsLoading ?
                            <div className="row past-res-card">
                                {past_reservations}
                                <div className="col-md-12 text-center"
                                     hidden={this.props.noMorePastReservations === true}>
                                    <div className="loading-more cursor-pointer"
                                         hidden={past_reservations.length < 6 || this.props.fetchMorePastReservation === true}
                                    >
                                        <div className="text-center">
                                            <a href="/" style={{pointerEvents: 'false'}}
                                               className="btn shadow-4d"
                                               onClick={(e) => this.loadMorePastReservations(e)}>{this.props.translate("fetch_more")}</a>
                                        </div>
                                    </div>

                                    <div className="loading-more" hidden={this.props.fetchMorePastReservation === false}>
                                        <div className="text-center">
                                            <img style={{width: '100px'}} src="/images/loading.svg" alt="loading"/>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            : (<div className="row">
                                {setUserHistorySkeleton(6)}
                            </div>)}
                    </div>
                    <div className="row">
                        <div className="col-md-12">
                            <div className="upcoming-res-flex" hidden={this.state.historyTab === "past"}>
                                {!this.props.upcomingReservationsIsLoading ?
                                    upcoming_reservations
                                    : setUpcomingReservationSkeleton(5)}
                            </div>
                        </div>
                    </div>

                    { /********************ADD REVIEW*******************/}
                    <div id="review-overlay" hidden={this.state.reviewPopUp === false}>
                        {this.state.currentPastReservation ?
                            <div className="review-overlay-content">
                                <img src={this.state.currentPastReservation.doctor.image} alt="doctor"/>
                                <h5 className="mt-20">{this.state.currentPastReservation.doctor.name}</h5>
                                <hr/>
                                <p className="capitalized font-20">{this.props.translate('rate_doctor')}</p>
                                <Rating
                                    onChange={(rate) => this.setReviewRate(rate)}
                                    initialRating={this.state.rate}
                                    emptySymbol="fa fa-star-o font-30 empty-star"
                                    fullSymbol="fa fa-star font-30 full-star"
                                    fractions={2}
                                />
                                <p className="capitalized font-20 mt-20">{this.props.translate('write_review')}</p>
                                <textarea id="content"
                                          onChange={(e) => this.handleInputChange(e)}
                                          value={this.state.content}
                                          className="form-control input100"
                                          placeholder={this.props.translate('write_your_review_here')}>
                                </textarea>
                                <div className="relative">
                                    <button className="cursor-pointer"
                                            onClick={(e) => this.setReservationReview(e, this.state.currentPastReservation)}>{this.props.translate('submit')}</button>
                                    <span id="loading" className="absolute" style={{left: "57%", top: "3%"}}
                                          hidden={this.state.loading === false}>
                                                    <img style={{width: "30px", height: "30px", marginTop: "15px"}}
                                                         src="/images/loading-white.svg" alt="loading"/>
                                                </span>
                                </div>
                            </div>
                            : null}

                        <img onClick={() => this.setState({reviewPopUp: false, rate: null, content: null})}
                             src="/images/close_button.png"
                             alt="close" className="close-on-mobile cursor-pointer"/>
                    </div>
                    {/*********************ADD REPORT*******************/}
                    <div id="add-report-overlay" hidden={this.state.addReportPopUp === false}>
                        {this.state.currentPastReservation ?
                            <div className="add-report-overlay-content">
                                <p className="capitalized bold font-20">{this.props.translate('report')}</p>
                                <select
                                    id="type"
                                    className="mobile-select custom-select capitalized"
                                    onChange={(e) => this.handleAddReportChange(e)}
                                >
                                    <option value="" disabled
                                            selected>{this.props.translate("select_issue") + "..."}</option>
                                    {reportIssuesList}
                                </select>
                                <textarea id="body"
                                          placeholder={this.props.translate('why_do_you_want_to_report_this_visit')}
                                          onChange={(e) => this.handleAddReportChange(e)}
                                          value={this.state.body}
                                          rows={5}
                                          className="form-control input100"
                                />
                                <a className="capitalized" href="tel://01116579777">
                                    {this.props.translate('or_call_us')}
                                    <i className="fa fa-phone"></i>
                                </a>
                                <div className="relative center">
                                    <button className="cursor-pointer"
                                            onClick={(e) => this.setPastReservationReport(e, this.state.currentPastReservation)}>{this.props.translate('submit')}</button>
                                    <span id="loading" className="absolute" style={{left: "57%", top: "17%"}}
                                          hidden={this.state.reportLoading === false}>
                                                    <img style={{width: "30px", height: "30px", marginTop: "15px"}}
                                                         src="/images/loading-white.svg" alt="loading"/>
                                                </span>
                                </div>
                            </div> : null}
                        <img onClick={() => this.setState({addReportPopUp: false, reportDesc: null})}
                             src="/images/close_button.png"
                             alt="close" className="close-on-mobile cursor-pointer"/>
                    </div>
                    {/*********************ADD REFUND*******************/}
                    <div id="refund-overlay" hidden={this.state.refundPopUp === false}>
                        {this.state.currentPastReservation ?
                            <div className="refund-overlay-content">
                                <p>{this.props.translate('refund_desc')}</p>
                                <div className="row mt-50" id="refund-area">
                                    <div className="col-md-12 refund-btn text-center relative">
                                        <button className="cursor-pointer" onClick={this.requestRefund}>
                                            {this.props.translate('agree')}
                                        </button>
                                        <span id="loading" className="refund-loading"
                                              hidden={this.state.requestRefundLoading === false}>
                                                    <img style={{width: "30px", height: "30px"}}
                                                         src="/images/loading-white.svg" alt="loading"/>
                                                </span>
                                    </div>
                                    {/*   <div className="col-md-12 refund-cancel-btn text-center">
                                       <p className="cursor-pointer" onClick={() => this.setState({refundPopUp: false, currentPastReservation: null})}>{this.props.translate('dont_agree')}</p>
                                    </div>*/}
                                </div>
                            </div>
                            : null}
                        <img onClick={() => this.setState({refundPopUp: false, currentPastReservation: null})}
                             src="/images/close_button.png"
                             alt="close" className="close-on-mobile cursor-pointer"/>
                    </div>
                </div>
                <SweetAlert
                    show={this.state.showSweetAlert}
                    title={this.state.sweetAlertTitle}
                    onConfirm={(e) => this.onConfirmSweetAlert(e)}
                    confirmBtnText={this.state.confirmSweetAlertBtnText}
                    warning
                    confirmBtnBsStyle="sweet success-sweet">
                    {this.state.requestSweetAlertText}
                </SweetAlert>
                <SweetAlert
                    show={this.state.showRequestSweetAlert}
                    title={this.props.translate("are_you_sure_ques")}
                    confirmBtnText={this.props.translate("ok")}
                    onConfirm={() => this.handleCancelReservation(this.state.reservation)}
                    showCancel
                    cancelBtnText={this.props.translate("cancel")}
                    cancelBtnBsStyle="sweet custom-danger"
                    confirmBtnBsStyle="sweet success-sweet"
                    onCancel={() => this.setState({showRequestSweetAlert: false})}>
                    {this.props.translate("cancel_reservation")}
                    <img src="../../images/loading.svg" alt="loading" className="width-50"
                         hidden={!this.state.isRemovingReservationFromList}/>
                </SweetAlert>
                {/********************* agree Request Refund ************/}
                <SweetAlert
                    show={this.state.showRequestRefund}
                    title={this.state.requestRefundTitle}
                    onConfirm={this.handleConfirmSweetAlert}
                    warning
                    confirmBtnBsStyle="sweet success-sweet"
                    confirmBtnText={this.props.translate("ok")}
                >
                    {this.state.requestRefundText}
                </SweetAlert>
            </div>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        pastReservationsIsLoading: state.reservation.pastReservationsIsLoading,
        pastReservations: state.reservation.pastReservations,
        upcomingReservations: state.reservation.upcomingReservations,
        upcomingReservationsIsLoading: state.reservation.upcomingReservationsIsLoading,
        fetchMorePastReservation: state.reservation.fetchMorePastReservation,
        noMorePastReservations: state.reservation.noMorePastReservations,
        error500: state.global.error500,
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        getPastReservations: (limit, offset) => dispatch(getPastReservations(limit, offset)),
        clearPastReservations: () => dispatch(clearPastReservations()),
        getUpcomingReservations: () => dispatch(getUpcomingReservations()),
        clearUpcomingReservations: () => dispatch(clearUpcomingReservations()),
        removeReservationFromList: (reservation) => {
            dispatch(removeReservationFromList(reservation))
        },
        setCurrentRoute: (route) => dispatch(setCurrentRoute(route)),
        clearError500: () => dispatch(clearError500())
    }
};
export default connect(mapStateToProps, mapDispatchToProps)(withTranslate(UserHistory));
